import Vue from 'vue'

const initialState = {
  list: [],
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getList({commit}, date) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`resource_management/resources/?date=${date}`).then(response => {
          commit('SET', {key: 'list', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    reserve({commit, state}, {resourceId, form}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`resource_management/resources/${resourceId}/reservation/`, form).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeReservation({commit, state}, {resourceId, reservationId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.delete(`resource_management/resources/${resourceId}/reservation/${reservationId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
